import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from "react-redux";
import {
  setExpandMenu,
} from "../common/redux/sidebarSlice";
const DarkMode = () => {
  const dispatch = useDispatch();

  const [isDarkMode, setIsDarkMode] = useState(() => {
    const darkMode = localStorage.getItem('darkMode');
    return darkMode === 'enabled';
  });

  // Tema dipasang ke <html>; kelas `activate` yang menentukan tombol mana yang
  // terlihat dihitung saat render, bukan lewat classList di dalam effect.
  useEffect(() => {
    document.documentElement.className = isDarkMode ? 'dark' : 'light';
  }, [isDarkMode]);

  const toggleMode = (mode) => {
    dispatch(setExpandMenu(mode ? 'enabled' : 'disabled'));
    setIsDarkMode(mode);
    localStorage.setItem('darkMode', mode ? 'enabled' : 'disabled');
  };


  return (
    <li className="nav-item">
      <div>
        <Link
          to="#"
          id="dark-mode-toggle"
          className={isDarkMode ? 'dark-mode-toggle' : 'dark-mode-toggle activate'}
          onClick={() => toggleMode(true)}
        >
          <i className="fa-solid fa-moon"></i>
        </Link>
        <Link
          to="#"
          id="light-mode-toggle"
          className={isDarkMode ? 'dark-mode-toggle activate' : 'dark-mode-toggle'}
          onClick={() => toggleMode(false)}
        >
          <i className="fa-solid fa-sun"></i>
        </Link>
      </div>
    </li>
  );
};

export default DarkMode;
